<div class="modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" (mousedown)="onBackdropClick($event)">
  <div [ngClass]="{
      'w-full max-w-sm': size === 'sm',
      'w-full max-w-lg': size === 'md',
      'w-full max-w-2xl': size === 'lg'
    }" class="bg-white rounded-lg shadow-lg relative">
    <div class="flex items-center justify-between px-6 py-4 border-b">
      <h2 class="text-lg font-semibold">{{ title }}</h2>
      <button (click)="close.emit()" class="text-gray-400 hover:text-gray-700">
        <span class="sr-only">Close</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <div class="px-6 py-4">
      <ng-content></ng-content>
    </div>
    <div class="px-6 py-3 border-t bg-gray-50">
      <ng-content select="[modal-footer]"></ng-content>
    </div>
  </div>
</div> 